module.exports = __webpack_public_path__ + "images/emoji/black_small_square.60b302343e2365579f3f.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/black_small_square.png
// module id = WiIJ
// module chunks = 13